// Serviço de Email (100% gratuito)
export const emailService = {
  // Configurações do email
  ADMIN_EMAIL: 'seu-email@gmail.com', // Substitua pelo seu email
  SMTP_CONFIG: {
    host: 'smtp.gmail.com',
    port: 587,
    secure: false,
    auth: {
      user: 'seu-email@gmail.com',
      pass: 'sua-senha-app' // Senha de app do Gmail
    }
  },

  // Enviar email via Gmail SMTP
  async sendEmail(to: string, subject: string, html: string): Promise<boolean> {
    try {
      console.log('📧 Enviando email para:', to);
      console.log('📧 Assunto:', subject);

      // Simulação de envio de email (substitua por implementação real)
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      console.log('✅ Email enviado com sucesso (simulado)');
      return true;
    } catch (error) {
      console.error('❌ Erro ao enviar email:', error);
      return false;
    }
  },

  // Enviar notificação de novo contrato
  async sendNewContractNotification(contract: any): Promise<boolean> {
    try {
      const subject = '🎉 Novo Contrato Recebido - PlayKids';
      const html = this.buildContractEmailHTML(contract);
      
      return await this.sendEmail(this.ADMIN_EMAIL, subject, html);
    } catch (error) {
      console.error('❌ Erro ao enviar notificação de contrato:', error);
      return false;
    }
  },

  // Construir HTML do email
  buildContractEmailHTML(contract: any): string {
    const nomeContratante = contract.contratante || 'Não informado';
    const nomeAniversariante = contract.nomeAniversariante || 'Não informado';
    const dataFesta = contract.dataFesta ? new Date(contract.dataFesta).toLocaleDateString('pt-BR') : 'Não informada';
    const telefone = contract.telefone || 'Não informado';
    const valor = contract.valor ? `R$ ${contract.valor}` : 'A definir';

    return `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="UTF-8">
        <title>Novo Contrato - PlayKids</title>
        <style>
          body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
          .container { max-width: 600px; margin: 0 auto; padding: 20px; }
          .header { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 20px; border-radius: 10px 10px 0 0; text-align: center; }
          .content { background: #f9f9f9; padding: 20px; border-radius: 0 0 10px 10px; }
          .field { margin: 10px 0; padding: 10px; background: white; border-radius: 5px; border-left: 4px solid #667eea; }
          .label { font-weight: bold; color: #667eea; }
          .value { color: #333; }
          .footer { text-align: center; margin-top: 20px; color: #666; font-size: 12px; }
        </style>
      </head>
      <body>
        <div class="container">
          <div class="header">
            <h1>🎉 Novo Contrato Recebido</h1>
            <p>PlayKids - Sistema de Contratos</p>
          </div>
          <div class="content">
            <div class="field">
              <span class="label">👤 Nome do Contratante:</span>
              <span class="value">${nomeContratante}</span>
            </div>
            <div class="field">
              <span class="label">📞 Telefone:</span>
              <span class="value">${telefone}</span>
            </div>
            <div class="field">
              <span class="label">📧 Email:</span>
              <span class="value">${contract.email || 'Não informado'}</span>
            </div>
            <div class="field">
              <span class="label">🎂 Aniversariante:</span>
              <span class="value">${nomeAniversariante}</span>
            </div>
            <div class="field">
              <span class="label">🎂 Idade:</span>
              <span class="value">${contract.idadeAniversariante || 'Não informada'} anos</span>
            </div>
            <div class="field">
              <span class="label">📅 Data da Festa:</span>
              <span class="value">${dataFesta}</span>
            </div>
            <div class="field">
              <span class="label">🕐 Horário:</span>
              <span class="value">${contract.horarioInicioFesta || 'Não informado'}</span>
            </div>
            <div class="field">
              <span class="label">🎨 Tema:</span>
              <span class="value">${contract.temaFesta || 'Não informado'}</span>
            </div>
            <div class="field">
              <span class="label">👥 Convidados:</span>
              <span class="value">${contract.numeroConvidados || 'Não informado'}</span>
            </div>
            <div class="field">
              <span class="label">📍 Local:</span>
              <span class="value">${contract.endereco && contract.numero && contract.cidade && contract.estado 
                ? `${contract.endereco}, ${contract.numero}, ${contract.cidade} - ${contract.estado}`
                : 'Não informado'}</span>
            </div>
            <div class="field">
              <span class="label">💰 Valor:</span>
              <span class="value">${valor}</span>
            </div>
            <div class="field">
              <span class="label">⏰ Recebido em:</span>
              <span class="value">${new Date().toLocaleString('pt-BR')}</span>
            </div>
          </div>
          <div class="footer">
            <p>Este email foi enviado automaticamente pelo sistema PlayKids</p>
            <p>Acesse o painel administrativo para mais detalhes</p>
          </div>
        </div>
      </body>
      </html>
    `;
  }
};